import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface SearchAuthDuplicatesResult {
  "authNo": string,
  "companyId": string,
  "status": string,
  "reqDate": string,
  "exprDate": string
};

export const validateDuplicateAuth = (payload: any) => async (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VALIDATE_DUPLICATE_AUTH_REQUEST });

  try {
    const res = await api.authorization.duplicateAuth.validateDuplicateAuth(payload);

    dispatch({
      type: types.VALIDATE_DUPLICATE_AUTH_SUCCESS,
      payload: res,
    });

    return res;
  } catch (err: any) {

    const msg = _get(err, 'response.data.msg', 'Post failed!');
    const errors = _get(err, 'response.data.errors', {});
    const payload = { ...err, msg, errors };

    dispatch({
      type: types.VALIDATE_DUPLICATE_AUTH_FAILURE,
      payload,
    });

    return Promise.reject(payload);
  }
};
